module.exports = __webpack_public_path__ + "img/kspp.3852c124.png";